(function () {
  'use strict';

  angular
      .module('eltazkara.topBar', [])

})();